import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-emoji-button',
  templateUrl: './emoji-button.component.html',
  styleUrls: ['./emoji-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmojiButtonComponent {
  @Output() emojiClicked = new EventEmitter<string>();

  emojiListOpened = false;
}
